import type React from 'react';
import { createContext, useContext, useEffect, useState } from 'react';

import type { Location } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

export const PreviousLocationContext = createContext<Location | undefined>(
  undefined,
);

/*
  The PreviousLocationContext keeps track of the previous location.
*/
export function PreviousLocationProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [prevLocation, setPrevLocation] = useState<Location>();
  const [currentLocation, setCurrentLocation] = useState<Location>();

  const location = useLocation();

  useEffect(() => {
    if (location.pathname === currentLocation?.pathname) {
      return;
    }

    setPrevLocation(currentLocation);
    setCurrentLocation(location);
  }, [currentLocation, location]);

  return (
    <PreviousLocationContext.Provider value={prevLocation}>
      {children}
    </PreviousLocationContext.Provider>
  );
}

export const usePreviousLocation = () => useContext(PreviousLocationContext);
